import { defineStore, acceptHMRUpdate } from 'pinia'

export interface EditBookingTypeData {
  // Pre-filled values when opening the booking type form for editing.

  name: string | null
  // Display name (e.g. a room or a performer).

  description: string | null
  // Optional description; null when absent.

  address: string | null
  // Optional address/location; null when absent.
}

export const useAddBookingTypeFormStore = defineStore('addBookingTypeForm', {
  state: () => ({
    isOpen: false,
    editId: null as string | null,
    editData: null as EditBookingTypeData | null,
  }),
  actions: {
    open(): void {
      this.isOpen = true
      this.editId = null
      this.editData = null
    },
    openForEdit(id: string, data: EditBookingTypeData): void {
      this.isOpen = true
      this.editId = id
      this.editData = data
    },
    close(): void {
      this.isOpen = false
      this.editId = null
      this.editData = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAddBookingTypeFormStore, import.meta.hot))
}
